import "view-design/dist/styles/iview.css";
import './styles/IconFont/iconfont.css';
import './styles/color.less';
import './styles/base.less';
import promise from "es6-promise";
import Vue from "vue";
import iView from "view-design";
import axios, { AxiosInstance } from "axios";
import { FilterHelper } from "@newview/tools";
import globalData from './global';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { dragscroll } from "./Tools";
Vue.use(VXETable)
import func from './plugins/preload.js'

declare module "vue/types/vue" {
  interface Vue {
    $axios: AxiosInstance;
  }
}

var EventBus = new Vue();

// Vue.prototype.$bus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

Vue.directive('dragscroll',dragscroll);

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    el.focus()
  }
});
Vue.directive('enterNumber', {
  bind: function (el: any, { value = 2 }) {
    el = el.nodeName == "INPUT" ? el : el.children[0]
    var RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`;
    el.addEventListener('keyup', function () {
      el.value = el.value.match(new RegExp(RegStr, 'g'));
      el.dispatchEvent(new Event('input'))
    })
  }
});
Vue.prototype.$func = func;

export function initIView() {
  Vue.use(iView);
  
  // //重写对象合并方法
  // Object.assign = function(target, ...sources){
  //   // 检查第一个参数是不是对象
  //   if (target === undefined || target === null) {
  //     throw new TypeError('Cannot convert undefined or null to object');
  //   }
  //   const output = Object(target); // 转换为对象
  //   sources.forEach(source => {
  //     if (source !== undefined && source !== null) {
  //       for (let key in source) {
  //         if (source.hasOwnProperty(key)) {
  //           Vue.set(output,key,source[key])
  //         }
  //       }
  //     }
  //   });
  //   return output;
  // }
}


export function initAxios(router) {
  Vue.use((v) => {
    v.prototype.$axios = axios;
  });

  Vue.config.productionTip = false;
  // newobj.menuName=
  // 拦截request请求
  axios.interceptors.request.use(
    function (config) {
      if(config.url && config.url.indexOf('auth/login')>-1) return config
      if(config.url && config.url.indexOf('auth/getOAuthByToken')>-1) return config
      if (config.url && config.url.indexOf('tecshield.com') > -1) return config;
      if (config.url && config.url.indexOf('ChatAI') > -1) return config;
      if (config.url && config.url.indexOf('https://tiles.geovisearth.com') > -1) return config;
      
      // 在发送请求之前加入token
      if(sessionStorage.getItem("token")!=""&&sessionStorage.getItem("token")!=null){
        if(config.url?.indexOf("ProcessApi")!=-1||config.url?.indexOf("SupportComApi")!=-1|| config.url?.indexOf("NetDbCenterApi")!=-1 ||
            config.url?.indexOf("ERMApi")!=-1 || config.url?.indexOf("SysDataApi")!=-1|| config.url?.indexOf("UploadApi")!=-1|| config.url?.indexOf("NetQualityApi")!=-1
            || config.url?.indexOf("SysApi")!=-1 || config.url?.indexOf("WBSImportApi")!=-1|| config.url?.indexOf("DicApi")!=-1){
          config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("netToken");

        }else{
          config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("token");
        }
        let newobj: any = {}
        if (localStorage.getItem("activeMenu") != "" && sessionStorage.getItem('globalData_Plms') != "") {
          const _menu: any = JSON.parse(localStorage.getItem("activeMenu")!)
          const _globalData: any = JSON.parse(sessionStorage.getItem('globalData_Plms')!);
          newobj.menuName = _menu.moduleName;
          newobj.menuId = _menu.id;
          newobj.menuPath = _menu.moduleUrl;
          newobj.projectId = _globalData.itemInfo.projectId
          newobj.projectDataId = _globalData.itemInfo.id
          newobj.userId = _globalData.localUser.id
          newobj.systemId = _globalData.subSysteminfor.id
          let url: any = config.url
          let list: any = url.split("/")
          newobj.url = list[1]
          config.headers["projectKey"] = encodeURI(_globalData.itemInfo.subProjectName);
        }
        if (config.params === undefined) {
          config.params = {};
        }
        // config.params["logData"] = newobj
        // config.params["nowtime"] = new Date().getTime();
      }else{
        router.push('/');
      }

      return config;
    },
    function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );


  // 拦截response信息
  axios.interceptors.response.use(
    function (config) {
      // 对response成功处理
      return config;
    },
    function (error) {
      console.log("error", error);
      // 对response错误处理
      if (error.response.status === 401) {
        // sessionStorage.removeItem("token");
        router.push('/')
      }
      if (error.response.status === 500) {
        // this.$Message.error('服务发生错误！');
      }
      if (error.response.status === 504) {
        // this.$Message.error('请求超时！');
      }
      return Promise.reject(error);
    }
  );


}

export function initFilter() {
  for (let key in FilterHelper) {
    Vue.filter(key, (val, value1, value2) => {
      return FilterHelper[key](val, value1, value2);
    });
  }
}

export function initPolyfill() {
  promise.polyfill();
}

export function initGlobal() {
  if (sessionStorage.getItem('token')) { // F5刷新页面时进行一些设置
    const _globalData: any = JSON.parse(sessionStorage.getItem('globalData_Plms')!);
    if (_globalData) {
      globalData.institutioninfor = _globalData.institutioninfor;
      globalData.itemInfo = _globalData.itemInfo;
      globalData.localUser = _globalData.localUser;
      globalData.roadInfo = _globalData.roadInfo;
      globalData.roleInfo = _globalData.roleInfo;
      globalData.subSysteminfor = _globalData.subSysteminfor;
    }
    
  }

  Vue.use(v => {
    v.prototype.$globalData_Plms = globalData
  })  
}

//动态插入公共路由
export function initCommonRouter(router) {
  new Vue({ router }).$router.addRoutes([
    {
      name: 'SysRoleSelect',
      path: '/SysRoleSelect',
      component: () => import('@newview/ui/src/components/subSystemMainPage.vue')
    },
    {
      name: 'BIMView',
      path: '/BIMView',
      component: () => import('@newview/ui/src/components/BIMView.vue')
    },
    {
      name: 'nvcenterPnl',
      path: '/nvcenterPnl',
      component: () => import('@newview/ui/src/components/FreeLogin/FreeLogin.vue')
    },
    {
      name: 'Root',
      path: '/Root',
      component: () => import('@newview/ui/src/components/Root.vue')
    },
  ])
}

